<template>
  <div class="w-search">
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="isDeviceManagement || isAudit ? 24 : 18">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="角色" v-if="isSystemSettings&&!isAudit">
            <el-select v-model="formInline.roleId" :size="size" placeholder="">
              <el-option label="全部" value="0"></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in roleIdList"
                :key="'roleId' + index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色" v-if="isSystemSettings && isAudit">
            <el-select v-model="formInline.roleId" :size="size" placeholder="">
              <el-option label="全部" value="0"></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in auditRoleIdList"
                :key="'roleId' + index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" v-if="isSystemSettings">
            <el-input
              v-model="formInline.name"
              :size="size"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="工作单位" v-if="isSystemSettings">
            <el-input
              v-model="formInline.company"
              :size="size"
              placeholder=""
            ></el-input>
          </el-form-item>

          <el-form-item label="站点名称" v-if="isDeviceManagement">
            <el-input
              class="w120px"
              v-model="formInline.siteName"
              :size="size"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="站点编号" v-if="isDeviceManagement">
            <el-input
              class="w120px"
              v-model="formInline.siteId"
              :size="size"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="站点类型" v-if="isDeviceManagement">
            <el-select
              class="w120px"
              v-model="formInline.source"
              :size="size"
              placeholder=""
            >
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="蓝牙站点" value="0"></el-option>
              <el-option label="虚拟站点" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态：" v-if="isSystemSettings && isAudit">
            <el-select v-model="formInline.status" :size="size" placeholder="">
              <el-option label="全部" :value="99"></el-option>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="已通过" :value="1"></el-option>
              <el-option label="已拒绝" :value="2"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="区域属性" v-if="isDeviceManagement">
            <el-select v-model="formInline.majorSwitch" :size="size">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="重点区域" :value="1"></el-option>
              <el-option label="一般区域" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :size="size" @click="onSubmit"
              >查询</el-button
            >
            <el-button :size="size" @click="onReset">重置</el-button>
            <el-button
              v-show="checkUserAuth(3, 18)"
              v-if="isDeviceManagement"
              :size="size"
              @click="onExport"
              >导出</el-button
            >
            <el-button
              v-show="checkUserAuth(3, 113)"
              v-if="isDeviceManagement && userLevel >= 2 && isAggregation"
              :size="size"
              @click="newSite"
              >添加虚拟站点</el-button
            >
            <el-button
              v-if="isDeviceManagement"
              :size="size"
              @click="multSet"
              >批量设置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col
        :span="6"
        v-if="!isDeviceManagement && isSystemSettings && !isAudit"
      >
        <div class="mt5 textRight">
          <el-button
            type="primary"
            :size="size"
            @click="onAdd"
            v-show="checkUserAuth(6, 30)"
            >添加账号</el-button
          >
          <el-button :size="size" @click="onAudit" v-show="checkUserAuth(6, 33)"
            >审核列表</el-button
          >
          <el-button :size="size" @click="onRole" v-show="checkUserAuth(6, 28)"
            >角色管理</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import WInputBox from './w-input-box'
import { mapGetters } from 'vuex'

export default {
  props: {
    roleIdList: {
      type: Array,
      default() {
        return []
      }
    },
    auditRoleIdList: {
      type: Array,
      default() {
        return []
      }
    },
    searchType: {
      type: String
    }
  },
  components: {
    WInputBox
  },
  data() {
    return {
      size: 'small',
      formInline: {
        roleId: '0',
        name: '',
        company: '',
        siteName: '',
        siteId: '',
        equipmentMac: '',
        equipmentSignal: '',
        equipmentPower: '',
        powerUpdateTime: '',
        source: '',
        siteCeiling: '',
        status: 99, // 审核状态
        auditRoleId: '0'
      }
    }
  },
  computed: {
    ...mapGetters(['currpath', 'user', 'isAggregation', 'userLevel']),
    isSystemSettings() {
      return (
        this.currpath &&
        (this.currpath.indexOf('/systemSettings') > -1 ||
          this.currpath.indexOf('/regionalSettings') > -1)
      )
    },
    isDeviceManagement() {
      return this.currpath && this.currpath.indexOf('/deviceManagement') > -1
    },
    isAudit() {
      return this.searchType === 'auditList'
    }
  },
  created() {
    if (this.$route.params) {
      if (this.$route.params.equipmentPower) {
        this.formInline.equipmentPower = this.$route.params.equipmentPower
        this.onSubmit()
      }
      if (this.$route.params.siteId) {
        this.formInline.siteId = this.$route.params.siteId
        this.onSubmit()
      }
    }
  },
  methods: {
    onRole() {
      this.$emit('onRole')
    },
    onSubmit() {
      console.log('submit!', this.formInline)
      if (this.isSystemSettings && !this.isAudit) {
        this.handleSystemSubmit()
      } else if (this.isDeviceManagement) {
        this.handleDeviceManagement()
      } else if (this.isSystemSettings && this.isAudit) {
        this.handleSystemIsAuditSubmit()
      }
    },
    handleSystemSubmit() {
      const params = {
        roleId: this.formInline.roleId,
        name: this.formInline.name,
        company: this.formInline.company
      }
      this.$emit('onSearch', params)
    },
    handleDeviceManagement() {
      const params = {
        siteName: this.formInline.siteName,
        siteId: this.formInline.siteId,
        equipmentMac: this.formInline.equipmentMac,
        equipmentSignal: this.formInline.equipmentSignal,
        equipmentPower: this.formInline.equipmentPower,
        powerUpdateTime: this.formInline.powerUpdateTime,
        source: this.formInline.source,
        siteCeiling: this.formInline.siteCeiling,
        majorSwitch: this.formInline.majorSwitch,
      }
      this.$emit('onSearch', params)
    },
    handleSystemIsAuditSubmit() {
      const params = {
        roleId: this.formInline.roleId,
        name: this.formInline.name,
        company: this.formInline.company,
        status: this.formInline.status
      }
      this.$emit('onSearch', params)
    },
    onReset() {
      if (this.isSystemSettings && !this.isAudit) {
        this.handleSystemReset()
      } else if (this.isDeviceManagement) {
        this.handleDeviceManagementReset()
      } else if (this.isSystemSettings && this.isAudit) {
        this.handleSystemResetIsAudit()
      }
    },
    handleSystemReset() {
      this.formInline.roleId = '0'
      this.formInline.name = ''
      this.formInline.company = ''
      this.$emit('onSearch', null)
    },
    handleDeviceManagementReset() {
      this.formInline.siteName = ''
      this.formInline.siteId = ''
      this.formInline.equipmentMac = ''
      this.formInline.equipmentSignal = ''
      this.formInline.equipmentPower = ''
      this.formInline.powerUpdateTime = ''
      this.formInline.source = ''
      this.formInline.siteCeiling = ''
      this.formInline.majorSwitch = ''

      this.$refs.equipmentSignal.clear()
      this.$refs.equipmentPower.clear()
    },
    handleSystemResetIsAudit() {
      this.formInline.roleId = '0'
      this.formInline.name = ''
      this.formInline.company = ''
      this.formInline.status = 99
      this.$emit('onSearch', this.formInline)
    },
    onAdd() {
      this.$emit('onAdd')
    },
    newSite() {
      this.$emit('newSite')
    },
    multSet() {
      this.$emit('multSet')
    },
    onExport() {
      const params = {
        siteName: this.formInline.siteName,
        siteId: this.formInline.siteId,
        equipmentMac: this.formInline.equipmentMac,
        equipmentSignal: this.formInline.equipmentSignal,
        equipmentPower: this.formInline.equipmentPower,
        powerUpdateTime: this.formInline.powerUpdateTime,
        source: this.formInline.source,
        siteCeiling: this.formInline.siteCeiling,
        majorSwitch: this.formInline.majorSwitch
      }
      this.$emit('onExport', params)
    },
    onAudit() {
      this.$emit('onAudit')
    }
  }
}
</script>

<style lang="less">
.w-search .el-form-item {
  margin-bottom: 0;
}
.w120px {
  width: 120px;
}
.w200px {
  width: 200px;
}
.w160px {
  width: 160px;
}
</style>
